<template lang="pug">
div.animated.fadeIn
  // conclusion by duration
  b-card
    div.row
      div.col-sm-4
      div.col-sm-8
        div.dateRangePickerContainer
          i(class="fa fa-calendar")
          date-range-picker.ml-2.dateRangePicker(ref="ref" :options="options")
          i(class="fa fa-caret-down")
    br
    div(id='graphContainer' style='height: 800px')
</template>

<script>
// import { db } from '@/firebase'
import echarts from 'echarts'
import $ from 'jquery'
// import sampleData from './sample-data.json'
var moment = require('moment')
// const anaRef = db.ref('analytics')

export default {
  name: 'dashboard',
  data() {
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      // for date range picker
      options: {
        startDate: moment().subtract(29, 'days'),
        endDate: moment(),
        locale: {
          format: 'DD/MM/YYYY',
        },
        ranges: {
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        },
      },
      yAxisLabels: [],
      sliderEndPoint: '',
      sliderStartPoint: '',
      option: null,
    }
  },
  mounted: function() {
    const el = $(this.$refs.ref.$el)
    el.on('apply.daterangepicker', (event, picker) => {
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      this.sliderEndPoint = `${picker.endDate.format('L').substring(3, 5)} ${monthNames[parseInt(picker.endDate.format('L').substring(0, 2)) - 1]}`
      this.sliderStartPoint = `${picker.startDate.format('L').substring(3, 5)} ${monthNames[parseInt(picker.startDate.format('L').substring(0, 2)) - 1]}`
      let sliderStartTime = new Date(picker.startDate.format('L'))
      let sliderEndTime = new Date(picker.endDate.format('L'))
      let dataStartTime = new Date(`${this.yAxisLabels[0]} 2019`)
      let dataEndTime = new Date(`${this.yAxisLabels[this.yAxisLabels.length - 1]} 2019`)
      if (sliderStartTime < dataStartTime) {
        this.sliderStartPoint = this.yAxisLabels[0]
      }
      if (sliderEndTime > dataEndTime) {
        this.sliderEndPoint = this.yAxisLabels[this.yAxisLabels.length - 1]
      }
      this.setOption(this.sliderEndPoint, this.sliderStartPoint, this.yAxisLabels, this.numberOfUsers, this.numberOfInteractions)
      var dom = document.getElementById('graphContainer')
      var myChart = echarts.init(dom)
      myChart.setOption(this.option, true)
    })
    this.getGraph()
  },
  methods: {
    getGraph() {
      var dom = document.getElementById('graphContainer')
      var myChart = echarts.init(dom)
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      let yAxisLabels = []
      let numberOfUsers = []
      let numberOfInteractions = []
      let lastDay = ''
      // Object.entries(sampleData.daily).forEach(
      //   function([key, val]) {
      //     lastDay = `${key.substring(6)} ${monthNames[parseInt(key.substring(4, 6)) - 1]}`
      //     yAxisLabels.push(lastDay)
      //     numberOfUsers.push(val.totals.users ? val.totals.users.total : 0)
      //     numberOfInteractions.push(val.totals.interactions ? val.totals.interactions.total : 0)
      //   }
      // )
      var year = 2019
      // sample data
      const todayDate = new Date()
      var date = +echarts.number.parseDate(year + '-01-01')
      var end = +echarts.number.parseDate(`${year}-${todayDate.getMonth() + 1}-${todayDate.getDate()}`)
      var dayTime = 3600 * 24 * 1000
      // var data = []
      for (var time = date; time <= end; time += dayTime) {
        var dateString = echarts.format.formatTime('yyyy-MM-dd', time)
        lastDay = `${dateString.substring(8)} ${monthNames[parseInt(dateString.substring(5, 7)) - 1]}`
        yAxisLabels.push(lastDay)
        let userNumber = Math.floor(Math.random() * 500)
        let botNumber = userNumber + Math.floor(Math.random() * 500)
        numberOfInteractions.push(botNumber)
        numberOfUsers.push(userNumber)
      }

      if (this.initialise) {
        this.sliderEndPoint = lastDay
        this.sliderStartPoint = yAxisLabels[yAxisLabels.length - 30]
        this.yAxisLabels = yAxisLabels
        this.numberOfUsers = numberOfUsers
        this.numberOfInteractions = numberOfInteractions
        this.initialise = false
      }
      this.setOption(this.sliderEndPoint, this.sliderStartPoint, this.yAxisLabels, this.numberOfUsers, this.numberOfInteractions)
      if (this.option && typeof this.option === 'object') {
        myChart.setOption(this.option, true)
      }
    },
    setOption(sliderEndPoint, sliderStartPoint, yAxisLabels, numberOfUsers, numberOfInteractions) {
      this.option = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Visitors Timeline'},
        legend: {
          top: 10,
          right: 100,
          data: ['Visitors Interaction', 'Visitors'],
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            animation: false,
            shadowStyle: {color: 'rgba(50,181,217,0.1)'},
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000',
          },
        },
        axisPointer: {
          link: {xAxisIndex: 'all'},
          label: {
            backgroundColor: '#777',
          },
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false,
            },
            restore: {},
            saveAsImage: {},
          },
        },
        grid: [
          {
            left: '10%',
            right: '8%',
            height: '50%',
          },
          {
            left: '10%',
            right: '8%',
            top: '63%',
            height: '16%',
          },
        ],
        xAxis: [
          {
            type: 'category',
            data: yAxisLabels,
            scale: true,
            boundaryGap: true,
            axisLine: {onZero: false},
            splitLine: {show: false},
            splitNumber: 20,
            min: 'dataMin',
            max: 'dataMax',
            axisPointer: {
              z: 100,
            },
          },
          {
            type: 'category',
            gridIndex: 1,
            data: yAxisLabels,
            scale: true,
            boundaryGap: true,
            axisLine: {onZero: false},
            axisTick: {show: false},
            splitLine: {show: false},
            axisLabel: {show: false},
            splitNumber: 20,
            min: 'dataMin',
            max: 'dataMax',
          },
        ],
        yAxis: [
          {
            scale: true,
            splitArea: {
              show: true,
            },
          },
          {
            scale: true,
            gridIndex: 1,
            splitNumber: 2,
            axisLabel: {show: false},
            axisLine: {show: false},
            axisTick: {show: false},
            splitLine: {show: false},
          },
        ],
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: [0, 1],
            startValue: sliderStartPoint,
            endValue: sliderEndPoint,
            // start: 50,
            // end: 100,
          },
          {
            show: true,
            smooth: true,
            xAxisIndex: [0, 1],
            type: 'slider',
            top: '85%',
            startValue: sliderStartPoint,
            endValue: sliderEndPoint,
            // start: 50,
            // end: 100,
          },
        ],
        series: [
          {
            name: 'Visitors',
            type: 'line',
            symbol: 'emptyCircle',
            symbolSize: 8,
            color: '#32b5d9',
            data: numberOfUsers,
            smooth: false,
            lineStyle: {
              color: '#32b5d9',
            },
          },
          {
            name: 'Visitors Interaction',
            type: 'line',
            symbol: 'circle',
            symbolSize: 8,
            color: '#6fdebd',
            label: {
              normal: {
                show: true,
                color: '#fff',
                position: 'top',
                padding: 2,
                borderRadius: 4,
                backgroundColor: '#6fdebd',
              },
            },
            data: numberOfInteractions,
            smooth: false,
            markLine: {
              silent: true,
              type: 'solid',
              label: {show: false},
              lineStyle: {
                color: '#ccc',
                type: 'solid',
              },
              symbol: 'none',
              data: [{
                xAxis: '01 Jan',
              }, {
                xAxis: '01 Feb',
              }, {
                xAxis: '01 Mar',
              }, {
                xAxis: '01 Apr',
              }, {
                xAxis: '01 May',
              }, {
                xAxis: '01 Jun',
              }, {
                xAxis: '01 Jul',
              }, {
                xAxis: '01 Aug',
              }, {
                xAxis: '01 Sep',
              }, {
                xAxis: '01 Oct',
              }, {
                xAxis: '01 Nov',
              }, {
                xAxis: '01 Dec',
              }],
            },
            lineStyle: {
              color: '#6fdebd',
            },
          },
          {
            name: 'Visitors',
            type: 'bar',
            color: '#32b5d9',
            label: {
              normal: {
                show: true,
                position: 'top',
              },
            },
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: numberOfUsers,
          },
        ],
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Analytics/VisitorTimeline.vue?bd023008